import { render } from "./redeem-voucher.vue?vue&type=template&id=7a5d1e00"
import script from "./redeem-voucher.vue?vue&type=script&lang=js"
export * from "./redeem-voucher.vue?vue&type=script&lang=js"
script.render = render

export default script